const stMob = {
  titlePage: {
    fontSize: '22px',
    fontWeight: 'bold',
  },
  subTitlePage: {
    fontSize: '18px',
  },
  containDetailsDiaria: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '0px 20px',
    overflow: 'auto',
    backgroundColor: 'white',
  },
  subTitleComp: {
    fontSize: '20px',
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'left',
    color: '#ff7043',
  },
  containLineComp: {
    display: 'flex',
    flexDirection: 'row',

    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingLeft: '10px',
  },
  textLabelComp: {
    fontSize: '16px',
    width: 'auto',
    textAlign: 'left',

    whiteSpace: 'nowrap',
  },
  textDescComp: {
    fontSize: '16px',
    width: '100%',
    textAlign: 'right',
    fontWeight: 'bold',
  },
  containImagem: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    height: '150px',
    width: '100%',
    margin: '10px 0px',
  },
  titleImagem: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    height: 'auto',
    width: 'auto',
    fontSize: '20px',
    fontWeight: 'bold',
    color: 'white',
    zIndex: '1',
  },
  imgContain: {
    height: '100%',
    width: '100%',
    borderRadius: '10px',

    filter: 'brightness(50%)',
    objectFit: 'cover',
  },
  containDetailsBorder: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '5px',
    backgroundColor: '#f0f0f0',
    borderRadius: '10px',
    marginBottom: '7px',
  },
}

export { stMob }
